import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrainingService {
  private trainingRef: firebase.firestore.CollectionReference; 
  //private trainingbannerRef: firebase.firestore.CollectionReference; 

  constructor() {
    this.trainingRef = firebase.firestore().collection(`${environment.firestorePath}/training`);
    //this.trainingbannerRef = firebase.firestore().collection(`${environment.firestorePath}/training-banner`);
  }


  async getAllTrainings(){
    try {
      const querySnapshot = await this.trainingRef.get();

      if (querySnapshot.empty) {
        throw new Error(`El endpoint no tiene registros...`);
      }
      
      const trainings = querySnapshot.docs.map(doc => {
        const obj = doc.data();
        obj.id = doc.id;
        return obj;
      });

      return trainings; 
    } catch (error) {
      throw new Error(error);
    }
  }

  /*async getTrainingBanner(){
    try {
      const querySnapshot = await this.trainingbannerRef.get();

      if (querySnapshot.empty) {
        throw new Error(`El endpoint no tiene registros...`);
      }
      
      const trainings = querySnapshot.docs.map(doc => {
        const obj = doc.data();
        obj.id = doc.id;
        return obj;
      });

      return trainings; 
    } catch (error) {
      throw new Error(error);
    }
  }*/
}
